<div class="bulk-upload-model-view tile-card-structure forecast-master-table-block mt-4">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="row" style="margin-top: 2%; margin-left: 5%">
      <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
          <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #1</p>
        </span>
        <span class="download-temaplte">
          <a [href]="Filepath" download>
            Download Template
          </a>
        </span>
      </div>
      <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
          <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #2</p>
        </span>
        <span class="">
          Add your data (changes only) in the Template.
        </span>
      </div>
      <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
          <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #3</p>
        </span>
        <span class="">
          <input
            type="file"
            [disabled]="!validTime"
            #fileInput
            id="uploadFile"
            (change)="uploadFileEvt($event.target.files)"
            name="uploadFile"
            accept=".xlsx"
          />
        </span>
      </div>
    </div>
    <div class="form-footer">
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
        @if (!showtable) {
        <button
          mat-mdc-raised-button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
          (click)="submitForm(false)"
          [disabled]="!showPreview"
        >
          Preview
        </button>
        } @if (showtable) {
        <button
          (click)="submitForm(true)"
          mat-mdc-raised-button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs "
          [disabled]="passdata.length < 1"
        >
          Submit
        </button>
        }
        <button
          (click)="cancelUpload()"
          mat-mdc-raised-button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs "
        >
          Cancel
        </button>
      </div>
    </div>
    <div class="row">
      @if (!showtable && missingColumns.length > 0) {
      <dev class="form-footer">
        <span class="label-invalid">{{ missingColumns.join(', ') }} columns are missing in uploaded file</span>
      </dev>
      } @if (!showtable && isDataLarge) {
      <dev class="form-text">
        <span class="label-invalid">File should not contain more than 2000 rows</span>
      </dev>
      } @if (!showtable && !validTime && !isForecastAdmin) {
      <dev class="form-text">
        <span class="label-invalid"
          >Forecast service details is no longer editable, please check the start and end date</span
        >
      </dev>
      } @if (!showtable && !validTime && isForecastAdmin) {
      <dev class="form-text">
        <span class="label-invalid"
          >Forecast service details is no longer editable for Forecast Admin, please check start and Admin End
          Date</span
        >
      </dev>
      } @if (showtable) {
      <!-- <h6 class="invalid-count"> Invalid count {{dataSourceDetails_fail.filteredData.length}}</h6> -->
      <app-maintenance-table
        [TABLE_CONFIG]="TABLE_CONFIG"
        [COLUMNS]="TABLE_COLUMNS_FAIL"
        [SORT_CONFIG]="sortConfig"
        [dataSource]="dataSourceDetails_fail"
        [SCHEMA]="DATA_SCHEMA"
        [isInvalidTable]="true"
        (filterApplied)="onFilterApplied($event)"
        (filterCleared)="onFilterCleared($event)"
      >
      </app-maintenance-table>
      <!-- <h6 class="valid-count"> Valid count {{dataSourceDetails_Pass.filteredData.length}}</h6> -->
      <app-maintenance-table
        [TABLE_CONFIG]="TABLE_CONFIG"
        [COLUMNS]="TABLE_COLUMNS_PASS"
        [SORT_CONFIG]="sortConfig"
        [dataSource]="dataSourceDetails_Pass"
        [SCHEMA]="DATA_SCHEMA"
        [isInvalidTable]="false"
      >
      </app-maintenance-table>
      }
    </div>
    @if (showLoader) {
    <div class="stk-table-loader bulk-loader">
      <app-loader> </app-loader>
    </div>
    }
  </div>
</div>
